import { Grid, Typography } from "@mui/material"
import { useTranslation } from "react-i18next"

const PaymentSummaryDetailsTotal = ({ paymentSummaryAmount}: { paymentSummaryAmount: string}) => {
    const { t } = useTranslation()

    return (
        <Grid container direction={`row`} justifyContent={`space-between`} alignItems={`start`}>
            <Typography variant={`subtitle1`}>{t(`payment_summary_details_membership_total`)}</Typography>
            <Typography variant={`subtitle1`}>{t(`payment_summary_amount`, { amount: paymentSummaryAmount })}</Typography>
        </Grid>
    )
}

export default PaymentSummaryDetailsTotal